import React from 'react'

import { NavLink } from 'react-router-dom'
import { IconCounter } from 'components'
import { LogoutIcon, BasketIcon, SearchIcon } from 'assets/icons'
import { ShopContext } from 'stores/ShopStore'

import './Navigation.scss'

export default class Navigation extends React.Component<Object> {

    public render() {

        return (
            <nav className="navigation">
                <ul>
                    <li>
                        <NavLink to="/logout">
                            <span className="u-hidden">Logout</span>
                            <LogoutIcon/>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/basket">
                            <span className="u-hidden">Basket</span>
                            <ShopContext.Consumer>
                                {(value: any) =>
                                    <IconCounter counter={value.basket.length}>
                                        <BasketIcon />
                                    </IconCounter>
                                }
                            </ShopContext.Consumer>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/search">
                            <span className="u-hidden">Search</span>
                            <SearchIcon/>
                        </NavLink>
                    </li>
                </ul>
            </nav>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Navigation/index.tsx